import React from 'react';
import { Button } from 'react-bootstrap';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Formatting from 'fw/misc/Formatting';
import * as ReportManager from 'modules/reports/ReportManager';

const handleDownload = (certificationId, prequalificationInfo, onClose) => {
	const rq = Object.assign({
		reportType: "PreQualificationInfoReport",
		format: "PDF",
		parameters: {
			CertificationId: certificationId,
			GrossAmount: Formatting.formatCurrency(prequalificationInfo.grossRevenue1Amount)
		}
	});

	ReportManager.execute(rq);
	onClose()
};

export const renderGrossRevenueTable = (state) => {
	return (
		<table className="table table-bordered table-condensed">
			<thead>
				<tr style={{backgroundColor:"#D3D1D0"}}>
					<th colSpan="2">
						Gross Revenue
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						{state.prequalificationInfo.grossRevenue1Year} Gross Revenue Amount
					</td>
					<td style={{ textAlign: "right" }}>
						<b>{Formatting.formatCurrency(state.prequalificationInfo.grossRevenue1Amount, 0)} USD</b>
					</td>
				</tr>
				<tr>
					<td>
						{state.prequalificationInfo.grossRevenue2Year} Gross Revenue Amount
					</td>
					<td style={{ textAlign: "right" }}>
						<b>{Formatting.formatCurrency(state.prequalificationInfo.grossRevenue2Amount, 0)} USD</b>
					</td>
				</tr>
			</tbody>
		</table>
	);
};

export const renderDownloadButton = (certificationId, prequalificationInfo, onClose) => {
	return (
		<div>
			<Button
				type="button"
				bsStyle="link"
				style={{ textAlign: 'center', display: 'block' }}
				onClick={() => handleDownload(certificationId, prequalificationInfo, onClose)}
			>
				Download Prequal Info
				<br />
				<FontAwesomeIcon icon={faFilePdf} size='3x' color='black' style={{ textAlign: 'center' }} />
			</Button>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/areas/shared/helpers/PreQualificationPopUpHelpers.js